// extracted by mini-css-extract-plugin
export var chevron = "_dw-2";
export var dropdownItems = "_dw-0";
export var item = "_dw-1";